"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMultiCurrencyInfo = exports.createFetchMultiCurrencyInfo = exports.fetchAllCurrencies = exports.createFetchAllCurrencies = void 0;

var _immutable = require("immutable");

var _formatReferences = require("../lib/formatReferences");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _get = _interopRequireDefault(require("transmute/get"));

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _formatMultiCurrencyInformation = _interopRequireDefault(require("../formatters/formatMultiCurrencyInformation"));

var formatter = (0, _formatReferences.formatToReferencesList)({
  getId: (0, _get.default)('fromCurrencyCode'),
  getLabel: (0, _get.default)('fromCurrencyCode')
});

var createFetchAllCurrencies = function createFetchAllCurrencies(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get('multi-currency/v1/currencies').then(function (result) {
      return (0, _immutable.List)(result).filter((0, _get.default)('active')).filter((0, _get.default)('visible'));
    }).then(function (response) {
      return (0, _indexBy.default)((0, _get.default)('id'), formatter(response));
    });
  };
};

exports.createFetchAllCurrencies = createFetchAllCurrencies;
var fetchAllCurrencies = createFetchAllCurrencies({
  httpClient: _apiClient.default
});
exports.fetchAllCurrencies = fetchAllCurrencies;

var createFetchMultiCurrencyInfo = function createFetchMultiCurrencyInfo(_ref2) {
  var httpClient = _ref2.httpClient;
  return function () {
    return httpClient.get('multi-currency/v1/currencies/information').then(_formatMultiCurrencyInformation.default);
  };
};

exports.createFetchMultiCurrencyInfo = createFetchMultiCurrencyInfo;
var fetchMultiCurrencyInfo = createFetchMultiCurrencyInfo({
  httpClient: _apiClient.default
});
exports.fetchMultiCurrencyInfo = fetchMultiCurrencyInfo;